var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#29A2EA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    xmlns: "http://www.w3.org/2000/svg",
    d: "M11.18,7.29a1,1,0,0,1,0,1.41l-.71.71L6.23,13.66a1,1,0,0,1-1.41-1.41L9.06,8,4.82,3.76A1,1,0,0,1,6.23,2.34l4.24,4.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteIcon);
export default __webpack_public_path__ + "static/media/sprite-icon.1ed84891e42713aaf7e9eb1e259909cc.svg";
export { ForwardRef as ReactComponent };